import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'priceSpace',
    standalone: false,
})
export class PriceSpacePipe extends DecimalPipe implements PipeTransform {
    public transform(value: any, digitsInfo?: string): any {
        return super.transform(value, digitsInfo);
    }
}
